import React from "react";
import Link from "next/link";
import styled from "styled-components";
import { Item } from "../../data/db/types";
import Button from "../buttons/Button";
import Heading from "../heading/Heading";
import { CATEGORY_SINGULAR_LABEL } from "../navigation/shared";
import { Stack } from "../Stack";
import Text from "../text/Text";

const SuggestContributionCtaElement = styled.div`
  margin-top: var(--spacing-level0);
`;
const SuggestContributionCtaHeading = styled(Heading)``;

type Props = {
  item: Item;
};

const SuggestContributionCta: React.FC<Props> = ({ item }) => {
  return (
    <SuggestContributionCtaElement>
      <Stack level="2">
        <SuggestContributionCtaHeading level="2">
          Would you like to suggest changes to this{" "}
          {CATEGORY_SINGULAR_LABEL[item._category]}?
        </SuggestContributionCtaHeading>
        <Text element="p">
          We encourage you to actively participate in the creation and
          moderation of our content—your contributions are invaluable. All
          content is reviewed by another community member.
        </Text>
        <Link href={`/contribute?_sourceId=${item._id}`} passHref>
          <Button as="a">Suggest edit</Button>
        </Link>
      </Stack>
    </SuggestContributionCtaElement>
  );
};

export default SuggestContributionCta;
